<nav class="navbar navbar-expand-xl bg-dark navbar-dark nav_styles"
    [ngClass]="{'disableSection':showPopUp || isSiteAffected || eventPopUpOpened}">
    <button id="collapseBtn" class="navbar-toggler" type="button" data-toggle="collapse"
        data-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <ul class="navbar-nav sub_menu">
            <li class="nav-item dropdown" *ngFor="let link of links; let i = index" (click)="clicked()">

                <a *ngIf="!link.children && link.id==10" class="nav-link anchor_color" [routerLink]="link.route"
                    routerLinkActive="active" (click)="home()" [hidden]="link.reportid==1">{{link.label}}</a>
                <a *ngIf="!link.children && link.id!=10" class="nav-link anchor_color" [routerLink]="link.route"
                    routerLinkActive="active" [hidden]="link.reportid==1">{{link.label}} </a>
                <a *ngIf="link.children" [hidden]="link.id >= 60" class="nav-link dropdown-toggle anchor_color"
                    id="{{ 'navbardrop' + i }}" data-toggle="dropdown" routerLinkActive="active">
                    {{link.label}}
                </a>
                <a *ngIf="link.children" [hidden]="link.id < 60 " class="sitelink nav-link dropdown-toggle anchor_color"
                    id="{{ 'navbardrop' + i }}" data-toggle="dropdown" (click)="isSiteClassVisible()"
                    routerLinkActive="active">
                    {{link.label}}
                </a>
                <a *ngIf="link.reportid==1" (click)="goToReport()" class="nav-link anchor_color"> {{link.label}}</a>

                <div class="dropdown-menu dropdown-div" [ngClass]="{'site-list-dropdown': isClassVisible }"
                    *ngIf="link.id >=60">
                    <a *ngFor="let childLink of link.children" [hidden]="link.id == 60" class="dropdown-item"
                        [routerLink]="childLink.route">{{childLink.label}}<span style="display:none"
                            *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span style="display:none"
                            *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                    <a *ngFor="let childLink of link.children" [hidden]="link.id != 60" class="dropdown-item"
                        (click)="childClicked(childLink.label,childLink.siteUniqueId)"
                        [routerLink]="childLink.route">{{childLink.label}}<span style="display:none"
                            *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span style="display:none"
                            *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                </div>
                <div class="dropdown-menu dropdown-div" *ngIf="link.id < 60">
                    <a *ngFor="let childLink of link.children;let in = index" id="{{'navbarChildLink'+in}}"
                        [hidden]="link.id == 60" class="dropdown-item" [routerLink]="childLink.route"
                        (click)="childLinkClicked(childLink.bpgId, childLink.siteId)">{{childLink.label}}<span
                            style="display:none" *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span
                            style="display:none" *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                    <a *ngFor="let childLink of link.children" [hidden]="link.id != 60" class="dropdown-item"
                        (click)="childClicked(childLink.label,childLink.siteUniqueId)"
                        [routerLink]="childLink.route">{{childLink.label}}<span style="display:none"
                            *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span style="display:none"
                            *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                </div>
                <div class="dropdown-menu dropdown-div" *ngIf="link.id1 >= 0">
                    <a *ngFor="let childLink of link.children;let in = index"
                        (click)="childLinkClickedNaac(childLink.naacId , childLink.label , childLink.naacAffinityId)"
                        id="{{'navbarChildLink'+in}}" [routerLink]="childLink.route"
                        class="dropdown-item">{{childLink.label}}</a>
                </div>
            </li>
        </ul>
    </div>


    <!--site menu for full scrn-->
    <div class="lastMenu">
        <ul class="navbar-nav sub_menu">
            <li class="nav-item dropdown" *ngFor="let link of links" [hidden]="link.id != 60">
                <a *ngIf="link.children" [hidden]="link.id < 60" class="nav-link dropdown-toggle anchor_color"
                    id="{{ 'navbardrop' + i }}" data-toggle="dropdown" (click)="isSiteClassVisible()"
                    routerLinkActive="active">
                    {{link.label}}
                </a>
                <div class="dropdown-menu dropdown-div" [ngClass]="{'site-list-dropdown': isClassVisible }"
                    *ngIf="link.id >=60">
                    <a *ngFor="let childLink of link.children;let in = index" id="{{'navbarChildLink'+in}}"
                        [hidden]="link.id == 60" class="dropdown-item"
                        [routerLink]="childLink.route">{{childLink.label}}<span style="display:none"
                            *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span style="display:none"
                            *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                    <a *ngFor="let childLink of link.children" [hidden]="link.id != 60" class="dropdown-item"
                        (click)="childClicked(childLink.label,childLink.siteUniqueId)"
                        [routerLink]="childLink.route">{{childLink.label}}<span style="display:none"
                            *ngIf="childLink.bpgId">{{childLink.bpgId}}</span><span style="display:none"
                            *ngIf="childLink.siteUniqueId">{{childLink.siteUniqueId}}</span></a>
                </div>
            </li>
        </ul>
    </div>
</nav>

<div class="popup" *ngIf="showPopUp">
    <div class="content">
        <h4>Please update your Email Address</h4>
        <input type="email" class="form-control width-class-email" placeholder="Enter Personal Email Address"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required name="email" ngModel #email="ngModel" id="email">
        <div class="validation-error-message" *ngIf="email.errors?.pattern">Please enter a valid Email Address</div>
        <button type="submit" class="btn btn-danger updateButton" (click)="updateEmail()"
            [disabled]="(email.invalid || (email==''))" data-toggle="modal" data-target="#myModal">UPDATE</button>
    </div>

</div>


<div class="site-popup" *ngIf="isSiteAffected">
    <div class="alert alert-success" *ngIf="siteUpdated">
        Site Updated Successfully!
    </div>
    <div class="label-heading">

        <div>Your Site location has been changed from <span class="font-weight-bold"
                class="color bold_text">{{oldSiteLocation}}</span> to <span
                class="color bold_text">{{newSiteLocation}}</span></div>
        <br> Do you wish to update the site location within BPG CONNECT?
        <div> 
            <div *ngIf="membershipsList.length>0">
                <div class="membership-style">
                    <span class="font"><br>Updating the Site location would have the following
                        changes to BPG
                        Memberships<br></span>
                    <div *ngFor="let a of membershipsList" style="display:flex;margin-top:0.5%;margin-bottom:0.5%">
                        <div style="width: 40%;text-align: left;padding-left:10%"><span
                                class="color bold_text">{{a.existingSite}}</span> - {{a.existingBpg}}</div>
                        <div style="width: 10%;"><i class="fa fa-sharp fa-regular fa-arrow-right"></i></div>
                        <div style="width: 40%;text-align: left;"><span class="color bold_text"> {{a.newSite}}</span> -
                            {{a.newBpg}} <span *ngIf="a.virtualMembership">( <span class="color bold_text">Virtual
                                </span>)</span>
                        </div>
                    </div>
                    <br>
                </div>
                <!-- <div *ngIf="leadershipsList" class="mt-3">  
    <div *ngFor="let a of leadershipsList"> -->
                <!-- <div class="leadership-box" style="font-size:12px"><div>
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>

                <span class="color bold_text"  >{{a.positionName}}</span>
                 position held at <span class="color bold_text">{{a.siteName}}</span> - {{a.bpgName}} would be impacted.
           
        </div> -->

                <div class="mt-3 mobile-view" style="font-size:12px;text-align: start">
                    <!-- <ul class="b"> -->
                    <span class="color mobile-view italic bold_text" style="font-size:14px;">Note:</span>
                    <!-- <li>Migrating to a different Site of the same BPG wouldn't have any impact with regards to the
                            participation in events or contribution to the community.</li> -->
                    <!-- <br> -->
                    <!-- <li>Virtual memberships are allowed only for BPG's that aren't available in User's Current
                            Location.</li> -->
                    <!-- <br> -->
                    <div class="italic">
                        For any queries or additional information, please feel free to reach out us at <span
                            class="color bold_text">BPGCONNECT@toyota.com</span>.
                        <!-- </ul> -->

                </div>
            </div>
        </div>
    </div>
    <div class="mt-3 mobile-view" style="font-size:12px;text-align: start">
    <input type="radio" style="vertical-align: bottom" id="sitePreference" name="sitePreference" value='new'
    [(ngModel)]="sitePreference"/><span style="margin-left:7px">I agree and wish to change my site location from {{oldSiteLocation}} to {{newSiteLocation}}.</span>
</div>
<div class="mt-2 mobile-view" style="font-size:12px;text-align: start">
<input type="radio" style="vertical-align: bottom" id="sitePreference" name="sitePreference" value='old'
[(ngModel)]="sitePreference"/><span style="margin-left:7px">I don't wish to change my site location right now.</span>
</div>
        <button type="submit" class="btn btn-danger updateButton mobile-view"  (click)="updateSite()" [disabled]="(sitePreference=='old' || sitePreference=='')">UPDATE</button>  
        <button type="submit" class="btn btn-danger updateButton ms-5 mobile-view" style="margin-left:3%"
            (click)="updateSite()" [disabled]="(sitePreference=='new' || sitePreference=='')">NO,
            THANKS</button>
        <!-- </div>   
       </div>  -->

    </div>
</div>
